<div class="file-uploader" [formGroup]="formGroup" [class.is-left]="alignLeft" [class.is-multi]="isMulti" [class.is-loading]="isLoading">
  <div class="file-uploader-chip-container">
    @for (file of files; track file; let i = $index) {
      @if (file.get('fileInfo').value) {
        <div class="file-uploader-chip" title="{{ file.get('fileInfo').value.name }}">
          <span>{{ file.get('fileInfo').value.name }}</span>
          <button type="button" class="file-uploader-delete" (click)="deleteFile(i)" [disabled]="isLoading"></button>
        </div>
      }
    }
  </div>

  @if (showAddButton) {
    <label [class.btn-disabled]="readonly" class="file-uploader-action btn btn-primary btn-add">
      <input
        type="file"
        class="file-uploader-input"
        accept="{{ accept }}"
        [attr.multiple]="isMulti ? 'multiple' : undefined"
        (change)="onChange($event)">
      @if (!isLoading) {
        <i class="far fa-paperclip fa-fw"></i>
      }
      @if (isLoading) {
        <i class="far fa-circle-notch fa-spin"></i>
      }
      <span [translate]="buttonKey"></span>
    </label>
  }
</div>

